<template>
  <div
    class="wf-relative"
    :class="!previewMode ? 'wf-border wf-border-transparent hover:wf-border-blue-300 wf-py-4 wf-pb-2 wf-px-1' : ''"
    @mouseover="hover = true"
    @mouseleave="hover = false"
  >
    <EditorOptions
      parent="component"
      v-show="hover && !previewMode"
      :options="menuOptions"
      :parentModule="parentModule"
    />
    <div
      class="wf-container-div"
      :class="elementClasses(classes('containerClasses'))"
      :style="elementStyles(styles('containerStyles'))"
    >
      <grid-layout
        v-if="content.type === 'grid'"
        :items="content.images"
        :classes="elementClasses(classes('classes'), classes('customClasses'))"
        :item-classes="elementClasses(classes('itemClasses'))"
        :content-classes="elementClasses(classes('contentClasses'))"
      />

      <masonry-layout
        v-else-if="content.type === 'masonry'"
        :items="content.images"
        :classes="elementClasses(classes('classes'))"
        :content-classes="elementClasses(classes('contentClasses'))"
        :item-classes="elementClasses(classes('itemClasses'))"
      />

      <slider-layout
        v-else-if="content.type === 'slider'"
        :items="content.images"
        :device="device"
        :number-images="content.numberImages"
        :slider-styles="elementStyles(styles('sliderStyles'))"
        :content-classes="elementClasses(classes('contentClasses'))"
        :button-classes="elementClasses(classes('buttonsClasses'))"
        :button-styles="elementStyles(styles('buttonsStyles'))"
        :dots-classes="elementClasses(classes('dotsClasses'))"
        :dots-styles="elementStyles(styles('dotsStyles'))"
        :active-dot-styles="elementStyles(styles('activeDotStyles'))"
      />
    </div>
  </div>
</template>

<script>
import GridLayout from "./EditorTools/GridLayout";
import MasonryLayout from "./EditorTools/MasonryLayout";
import SliderLayout from "./EditorTools/SliderLayout";
import EditorComponent from "../contracts/EditorComponent";
import { Unsplash } from '../libs/Unsplash'

export default EditorComponent.extend({
  components: {
    GridLayout, MasonryLayout, SliderLayout
  },

  mounted() {
    (new Unsplash()).build().then( item => {
      this.addToObject(this.module, { images:item }, 'content', null, {}, true, this.parentModule)
    })
  }
});
</script>
